import { ContentDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.content";
import { StaticDatabaseContext } from "@-/dev.improve.haniverse.contexts.database.static";
import { useContextSelectors } from "@-/com.npmjs.use-context-selectors";
import { useMorphemeCorpusFilter } from "@-/dev.improve.haniverse.lib.morpheme.corpus.use";
import { createUseQueryOptions } from "@-/dev.improve.haniverse.lib.query-options";
import { searchMorphemes, type SearchMorphemesOptions } from "#search-morphemes-core";

export function useGetSearchMorphemesQueryKey() {
  const [contentDb] = useContextSelectors(ContentDatabaseContext, (c) => c.db);
  const [staticDb] = useContextSelectors(StaticDatabaseContext, (c) => c.db);
  const corpusFilter = useMorphemeCorpusFilter();

  // `corpusFilter.cacheKey` keys the ranking by the user's corpus: the filter object itself
  // carries predicate functions, which a query-key hash silently drops.
  return (query: string, { exactOnly = false, pinyin }: SearchMorphemesOptions = {}) =>
    [
      "searchMorphemes",
      query.trim(),
      corpusFilter.cacheKey,
      { exactOnly, pinyin },
      { contentDb, corpusFilter, staticDb },
    ] as const;
}

export const [useSearchMorphemesQueryOptions, searchMorphemesQueryFn] = createUseQueryOptions(
  useGetSearchMorphemesQueryKey,
  ({
    queryKey: [_, trimmedQuery, _corpusCacheKey, options, { contentDb, corpusFilter, staticDb }],
  }) => {
    return searchMorphemes(contentDb, staticDb, trimmedQuery, corpusFilter, options);
  },
);
